import {NgModule} from '@angular/core';
import {SpecialistListPreviewComponent} from './components/specialist-list-preview/specialist-list-preview.component';
import {CommonModule} from '@angular/common';
import {ModalModule} from '@components/modal/modal.module';
import {ReactiveFormsModule} from '@angular/forms';
import {SpecialistEditModalComponent} from './components/specialist-edit-modal/specialist-edit-modal.component';
import {SpecialistFormComponent} from './components/specialist-form/specialist-form.component';
import {LayoutModule} from '../../layout-components/layout.module';
import {SpecialistFormFieldsModule} from '../../subforms/specialist-form-fields/specialist-form-fields.module';
import {SpecialistChoseModalComponent} from './components/specialist-chose-modal/specialist-chose-modal.component';
import {SpecialistAddButtonComponent} from './components/specialist-add-button/specialist-add-button.component';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {SpecialistViewModule} from '../specialist-view/specialist-view.module';
import {PipesModule} from '@pipes/pipes.module';
import {SpecialistControlSelectComponent} from './components/specialist-control-select/specialist-control-select.component';
import {
    SpecialistWizardListPreviewComponent
} from './components/specialist-list-preview/specialist-wizard-list-preview/specialist-wizard-list-preview.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ModalModule,
        LayoutModule,
        SpecialistFormFieldsModule,
        FormFieldModule,
        SpecialistViewModule,
        PipesModule,
        DirectivesModule,
        IconsModule,
    ],
    exports: [
        SpecialistListPreviewComponent,
        SpecialistFormComponent,
        SpecialistAddButtonComponent,
        SpecialistControlSelectComponent,
        SpecialistWizardListPreviewComponent,
    ],
    declarations: [
        SpecialistListPreviewComponent,
        SpecialistEditModalComponent,
        SpecialistFormComponent,
        SpecialistChoseModalComponent,
        SpecialistAddButtonComponent,
        SpecialistControlSelectComponent,
        SpecialistWizardListPreviewComponent,
    ],
    entryComponents: [
        SpecialistEditModalComponent,
        SpecialistChoseModalComponent,
    ],
    providers: [],
})
export class SpecialistsModule {
}
